import {NgModule} from "@angular/core";
import {IntScrollContainerComponent} from "./int-scroll-container.component";

@NgModule({
  declarations: [
    IntScrollContainerComponent
  ],
  exports: [
    IntScrollContainerComponent
  ]
})
export class IntScrollContainerModule {}
